export enum WgApplicationsEnum {
  NONE = 0,
  IMMIGRATION_CANADA = 1,
  CONCURSEIROS_BRASIL = 2,
  HR_TECH = 3,
}